import styled, { css } from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

const headingStyles = css`
  ${setFontVariant('h5', colorsPalettes.carbon[400])};
  font-weight: 700;
  margin: 24px 0;
  text-align: center;
  max-width: 308px;
`;

const subtextStyles = css`
  ${setFontVariant('subsectionTitle', colorsPalettes.carbon[300])};
  font-weight: 400;
  padding: 0 5px;
  text-align: center;
`;

const emailAgentStyles = css`
  ${setFontVariant('caption', colorsPalettes.carbon[250])};
  font-weight: 400;
  padding: 0 5px;
  text-align: center;
`;

export const StyledAnimatedText = styled.span<{ $variant: 'heading' | 'subtext' | 'emailAgent' }>`
  ${({ $variant }) =>
    $variant === 'heading' ? headingStyles : $variant === 'subtext' ? subtextStyles : emailAgentStyles};
`;
